var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionCompletedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4322_19167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4322_19167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30016 11.9835L5.16683 9.85016L5.8835 9.1335L7.30016 10.5502L10.1168 7.7335L10.8335 8.45016L7.30016 11.9835ZM3.5335 14.3335C3.20016 14.3335 2.91683 14.2168 2.6835 13.9835C2.45016 13.7502 2.3335 13.4668 2.3335 13.1335V4.20016C2.3335 3.86683 2.45016 3.5835 2.6835 3.35016C2.91683 3.11683 3.20016 3.00016 3.5335 3.00016H4.46683V1.5835H5.4835V3.00016H10.5335V1.5835H11.5335V3.00016H12.4668C12.8002 3.00016 13.0835 3.11683 13.3168 3.35016C13.5502 3.5835 13.6668 3.86683 13.6668 4.20016V13.1335C13.6668 13.4668 13.5502 13.7502 13.3168 13.9835C13.0835 14.2168 12.8002 14.3335 12.4668 14.3335H3.5335ZM3.5335 13.3335H12.4668C12.5113 13.3335 12.5557 13.3113 12.6002 13.2668C12.6446 13.2224 12.6668 13.1779 12.6668 13.1335V6.86683H3.3335V13.1335C3.3335 13.1779 3.35572 13.2224 3.40016 13.2668C3.44461 13.3113 3.48905 13.3335 3.5335 13.3335Z",
    fill: "#366EE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCompletedIcon);
export default __webpack_public_path__ + "static/media/session-completed-icon.fa0f09ccffc8fb0bdbb265e8365178ac.svg";
export { ForwardRef as ReactComponent };